 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACKCOVERTEXT from '@/components/BackCoverText'
 import DEARREADER from '@/components/DearReader'
 import PRAISE from '@/components/Praise'
 import TITLEPAGE from '@/components/TitlePage'
 import LOVEWITHTHEPROPERSTRANGER from '@/components/LovewiththeProperStranger'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import PROLOGUE from '@/components/Prologue'
 import CHAPTERONE from '@/components/ChapterOne'
 import CHAPTERTWO from '@/components/ChapterTwo'
 import CHAPTERTHREE from '@/components/ChapterThree'
 import CHAPTERFOUR from '@/components/ChapterFour'
 import CHAPTERFIVE from '@/components/ChapterFive'
 import CHAPTERSIX from '@/components/ChapterSix'
 import CHAPTERSEVEN from '@/components/ChapterSeven'
 import CHAPTEREIGHT from '@/components/ChapterEight'
 import CHAPTERNINE from '@/components/ChapterNine'
 import CHAPTERTEN from '@/components/ChapterTen'
 import CHAPTERELEVEN from '@/components/ChapterEleven'
 import CHAPTERTWELVE from '@/components/ChapterTwelve'
 import CHAPTERTHIRTEEN from '@/components/ChapterThirteen'
 import CHAPTERFOURTEEN from '@/components/ChapterFourteen'
 import CHAPTERFIFTEEN from '@/components/ChapterFifteen'
 import LETTERSTOKELLYOFBOOK2 from '@/components/LetterstoKellyofbook2'
 import DEDICATIONOFBOOK2 from '@/components/Dedicationofbook2'
 import CONTENTSOFBOOK2 from '@/components/Contentsofbook2'
 import CHAPTERONEOFBOOK2 from '@/components/ChapterOneofbook2'
 import CHAPTERTWOOFBOOK2 from '@/components/ChapterTwoofbook2'
 import CHAPTERTHREEOFBOOK2 from '@/components/ChapterThreeofbook2'
 import CHAPTERFOUROFBOOK2 from '@/components/ChapterFourofbook2'
 import CHAPTERFIVEOFBOOK2 from '@/components/ChapterFiveofbook2'
 import CHAPTERSIXOFBOOK2 from '@/components/ChapterSixofbook2'
 import CHAPTERSEVENOFBOOK2 from '@/components/ChapterSevenofbook2'
 import CHAPTEREIGHTOFBOOK2 from '@/components/ChapterEightofbook2'
 import CHAPTERNINEOFBOOK2 from '@/components/ChapterNineofbook2'
 import CHAPTERTENOFBOOK2 from '@/components/ChapterTenofbook2'
 import CHAPTERELEVENOFBOOK2 from '@/components/ChapterElevenofbook2'
 import CHAPTERTWELVEOFBOOK2 from '@/components/ChapterTwelveofbook2'
 import CHAPTERTHIRTEENOFBOOK2 from '@/components/ChapterThirteenofbook2'
 import CHAPTERFOURTEENOFBOOK2 from '@/components/ChapterFourteenofbook2'
 import CHAPTERFIFTEENOFBOOK2 from '@/components/ChapterFifteenofbook2'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/ChapterOne",
 			"name" : "ChapterOne",
 			"component" : CHAPTERONE
 		},
 		{
 			"path" : "/ChapterTwo",
 			"name" : "ChapterTwo",
 			"component" : CHAPTERTWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js